import React, { useContext, useState } from 'react'
import Select from 'react-select'
import ViewSlotIcon from 'src/assets/Content-Icons/PNGs/view-slot-icon.png'
import DeleteIcon from 'src/assets/iptv-delete-icon.svg'
import DateIcon from 'src/assets/Content-Icons/dateicon'
import CautionIcon from 'src/assets/caution-icon.svg'
import DatePicker from 'react-date-picker'
import TimePicker from 'src/components/timePicker/timePicker'
import { useEffect } from 'react'
import { concatDateTimeToIso, getThumbnail } from '../../utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { isEmpty } from 'lodash'
import { AppContext } from 'src/views/context/app'
import moment from 'moment'

const repeatOptions = [
  {
    label: 'Does not repeat',
    value: 'NO_REPEAT',
  },
  {
    label: 'Daily',
    value: 'DAILY',
  },
  {
    label: 'Weekly once',
    value: 'WEEKLY',
  },
  {
    label: 'Monthly once',
    value: 'MONTHLY',
  },
  {
    label: 'Every Weekday(Mon-Fri)',
    value: 'WEEKDAYS',
  },
]

const IPTVContentSlot = ({
  data,
  slotIndex,
  setIptvScheduleData,
  iptvScheduleData,
  error,
  // errorDataTimeDifference,
  channelsMaster,
  onDelete,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { setIptvScheduleModalProps } = useContext(AppContext)
  const [channel, setChannel] = useState({
    value: '',
    label: '',
  })

  // start datetime for a channel content
  const [startDate, setStartDate] = useState(new Date())
  const [startTime, setStartTime] = useState()
  // ending datetime for a channel content
  const [endDate, setEndDate] = useState(new Date())
  const [endTime, setEndTime] = useState()
  // expire datetime for a channel content
  const [expireDate, setExpireDate] = useState('')
  const [expireTime, setExpireTime] = useState(
    new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
  )

  const [channelContentObj, setChannelContentObj] = useState({
    channel_id: '',
    start_time: '',
    end_time: '',
    repeat_policy: 'NO_REPEAT',
    expires_on: '',
  })

  useEffect(() => {
    if (!isEmpty(data)) {
      setChannelContentObj(data)

      if (data?.start_time) {
        setStartDate(new Date(data['start_time']))
        setStartTime(
          new Date(data['start_time']).toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
      if (data?.end_time) {
        setEndDate(new Date(data['end_time']))
        setEndTime(
          new Date(data['end_time']).toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
      if (data?.expires_on) {
        setExpireDate(new Date(data['expires_on']))
        setExpireTime(
          new Date(data['expires_on']).toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
      let ChannelObj = channelsMaster.find((info) => info._id === data.channel_id)

      if (ChannelObj) {
        setChannel({
          value: ChannelObj._id,
          label: (
            <div className="d-flex">
              <img
                style={{ width: '15px', height: '15px' }}
                alt="rating"
                src={getThumbnail(
                  userSessionObj.session_data.cf_domain_name,
                  ChannelObj?.thumbnail?.website?.s3_key,
                )}
                className="mx-1"
              />
              <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
                {ChannelObj?.name}
              </span>
            </div>
          ),
        })
      }
    }
  }, [data, channelsMaster])

  useEffect(() => {
    if (!isEmpty(channelContentObj) && channelContentObj.channel_id) {
      let tempSlots = [...iptvScheduleData]
      tempSlots[slotIndex] = channelContentObj
      setIptvScheduleData(tempSlots)
    }
  }, [channelContentObj])

  const onChannelChange = (obj) => {
    setChannel(obj)
    setChannelContentObj((prev) => ({ ...prev, channel_id: obj.value }))
  }
  const getChannelOptions = () => {
    return channelsMaster.map((info) => ({
      value: info?._id,
      label: (
        <div className="d-flex">
          <img
            style={{ width: '15px', height: '15px' }}
            alt="rating"
            src={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              info?.thumbnail?.website?.s3_key,
            )}
            className="mx-1"
          />
          <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
            {info?.name}
          </span>
        </div>
      ),
    }))
  }

  const handleDateChange = (value, stateFunc, timeState, channelKey) => {
    stateFunc(value)
    let tempObj = channelContentObj

    if (channelKey === 'start_time' && endDate && moment(value).isAfter(moment(endDate))) {
      setEndDate(value)
      tempObj['end_time'] = concatDateTimeToIso(value, endTime)
    }

    tempObj[channelKey] = concatDateTimeToIso(value, timeState)
    setChannelContentObj({ ...tempObj })
  }
  const handleTimeChange = (value, stateFunc, dateState, channelKey) => {
    stateFunc(value)
    let tempObj = channelContentObj
    tempObj[channelKey] = concatDateTimeToIso(dateState, value)
    setChannelContentObj({ ...tempObj })
  }

  return (
    <div
      className="slot d-flex justify-content-between relative"
      style={{
        background: '#f8f8f8',
        minHeight: '9vw',
        padding: '0.9vw',
        marginBottom: '.75vw',
        borderRadius: '4px',
        border: `2px solid ${error ? '#d80101' : '#84848480'} `,
      }}
    >
      <div
        className="align-self-center text-center d-flex align-items-center"
        style={{ width: '4.5%', borderRight: '1px solid #707070', minHeight: '7.5vw' }}
      >
        <h6 style={{ fontSize: '.8vw' }}>Slot {slotIndex + 1}</h6>
      </div>
      <div style={{ width: '95%' }} className="d-flex flex-col">
        <div
          style={{ width: '100%', background: 'none' }}
          className=" d-flex justify-between align-items-center"
        >
          <div style={{ marginTop: '0', width: '67%' }}>
            <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
              IPTV Channel <span className="asterisk">*</span>
              <span style={{ fontWeight: '400', fontSize: '.6vw', marginLeft: '.75rem' }}>
                (Select a Channel for the content to be mapped)
              </span>
            </h6>
            <div>
              <Select
                value={channel}
                onChange={onChannelChange}
                options={getChannelOptions()}
                isSearchable={false}
                styles={{ height: '30px' }}
              />
            </div>
            {/* <div className="message-text error-message">
            <p>{errorDataChannel}</p>
          </div> */}
          </div>
          {error ? (
            <div
              style={{ color: '#d80101', top: '0.5vw', right: '1vw' }}
              className="absolute message-text d-flex"
            >
              <img
                className="mx-1"
                style={{ width: '14px', height: '14px' }}
                src={CautionIcon}
                alt="caution"
              />
              <p className="" style={{ fontSize: 'max(.55vw,10px)' }}>
                {error}
              </p>
            </div>
          ) : null}
          <div
            style={{ marginTop: '1.2vw', width: '27%' }}
            className="d-flex justify-content-between align-items-center"
          >
            <div
              className="d-flex justify-content-center align-items-center rounded-1"
              style={{
                height: 'max(1.65vw,34px)',
                backgroundColor: '#000',
                color: '#fff',
                padding: '8px 5px',
                cursor: 'pointer',
                width: '70%',
              }}
              onClick={() => {
                if (channel?.value) {
                  setIptvScheduleModalProps({ channelId: channel.value })
                }
              }}
            >
              <img src={ViewSlotIcon} alt="" className="h-100" />
              <p
                style={{
                  marginLeft: '1em',
                  marginBlock: '0',
                  fontWeight: '600',
                  fontSize: 'max(.60vw,9px)',
                }}
              >
                View Available Slot
              </p>
            </div>
            {slotIndex ? (
              <div style={{ width: '25%' }} className=" d-flex justify-content-center">
                <img onClick={onDelete} src={DeleteIcon} alt="" className="h-100 cursor-pointer" />
              </div>
            ) : null}
          </div>

          {/* <div className="message-text error-message">
          <p>{errorDataTimeDifference}</p>
        </div> */}
        </div>
        <div style={{ width: '100%' }} className=" d-flex justify-between align-items-center">
          <div className="" style={{ width: '67%' }}>
            <div className="d-flex flex-wra iptv-channels-start-en" style={{ marginTop: '.8vw' }}>
              {/* <div className="d-flex"> */}
              <div>
                <h6 style={{ fontSize: '.65vw' }}>
                  START TIME<span className="asterisk">*</span>
                </h6>
                <div className="d-flex">
                  <div>
                    <DatePicker
                      className="date-picker-pricing"
                      // onChange={setStartDate}
                      onChange={(value) =>
                        handleDateChange(value, setStartDate, startTime, 'start_time')
                      }
                      value={startDate}
                      minDate={startDate ? '' : new Date()}
                      format="dd/MM/y"
                      calendarIcon={<DateIcon />}
                    />
                  </div>
                  <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                    <TimePicker
                      time={startTime}
                      // setTime={setStartTime}
                      setTime={(value) =>
                        handleTimeChange(value, setStartTime, startDate, 'start_time')
                      }
                      customFontSize={'max(.65vw,9px)'}
                      customPadding={'.2vw .25vw'}
                      customWidth={'15ch'}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginLeft: '1.5vw' }}>
                <h6 style={{ fontSize: '.65vw' }}>
                  END TIME<span className="asterisk">*</span>
                </h6>
                <div className="d-flex">
                  <div>
                    <DatePicker
                      className="date-picker-pricing"
                      // onChange={setEndDate}
                      onChange={(value) => handleDateChange(value, setEndDate, endTime, 'end_time')}
                      value={endDate}
                      minDate={startDate}
                      format="dd/MM/y"
                      calendarIcon={<DateIcon />}
                    />
                  </div>
                  <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                    <TimePicker
                      time={endTime}
                      // setTime={setEndTime}
                      setTime={(value) => handleTimeChange(value, setEndTime, endDate, 'end_time')}
                      customFontSize={'max(.65vw,9px)'}
                      customPadding={'.2vw .25vw'}
                      customWidth={'15ch'}
                    />
                  </div>
                </div>
              </div>
              {/* </div> */}
              <div
                style={{
                  fontSize: '.65vw',
                  marginLeft: '1.5vw',
                  width: '7.5vw',
                }}
              >
                <h6 style={{ fontSize: '.65vw' }}>Set Recurring</h6>
                <select
                  value={channelContentObj.repeat_policy}
                  onChange={(e) =>
                    setChannelContentObj((prev) => ({ ...prev, repeat_policy: e.target.value }))
                  }
                  className="px-1 py-2 w-100"
                >
                  {repeatOptions.map((option, idx) => (
                    <option value={option.value} key={idx}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {channelContentObj.repeat_policy !== 'NO_REPEAT' && (
            <div style={{ marginTop: '1vw', width: '27%' }} className=" iptv-channels-start-end">
              <h6 style={{ fontSize: '.65vw' }}>EXPIRES ON</h6>
              <div className="d-flex">
                <div>
                  <DatePicker
                    className="date-picker-pricing"
                    // onChange={setExpireDate}
                    onChange={(value) =>
                      handleDateChange(value, setExpireDate, expireTime, 'expires_on')
                    }
                    value={expireDate}
                    minDate={startDate}
                    format="dd/MM/y"
                    calendarIcon={<DateIcon />}
                  />
                </div>
                <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                  <TimePicker
                    time={expireTime}
                    // setTime={setExpireTime}
                    setTime={(value) =>
                      handleTimeChange(value, setExpireTime, expireDate, 'expires_on')
                    }
                    customFontSize={'max(.65vw,9px)'}
                    customPadding={'.2vw .25vw'}
                    customWidth={'15ch'}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default IPTVContentSlot
